import type { FuturIAOggiData } from "../futur-ia-oggi";

export const futurIAOggiFixture: FuturIAOggiData = {
  unreadInternalEmails: 4,
  yesterdayTasks: 1,
  availableHours: 2,
  suggestion: "Puoi recuperare l’attività di ieri nello spazio libero delle 14:00.",
  priorities: [
    { id: "priority-1", title: "Verificare clausola penale", client: "Alfa S.r.l.", context: "Contratto di fornitura", duration: "30 min", due: "Scaduta ieri", status: "Da ieri" },
    { id: "priority-2", title: "Inviare follow-up al cliente", client: "Alfa S.r.l.", context: "Entro le 16:30", duration: "15 min", due: "Oggi", status: "Da fare" },
    { id: "priority-3", title: "Rivedere la bozza dell’ebook", client: "Progetto interno", context: "Entro oggi", duration: "45 min", due: "Oggi", status: "In corso" },
  ],
  emails: [
    { id: "mail-1", sender: "Amedeo Perna", initials: "AP", subject: "Feedback sul preventivo NIS2", preview: "Le mie note sono pronte per la revisione.", time: "08:54", folder: "Interne" },
    { id: "mail-2", sender: "Giulia Rossi", initials: "GR", subject: "Documenti Alfa aggiornati", preview: "Ho aggiunto gli allegati alla pratica.", time: "08:31", folder: "Interne" },
    { id: "mail-3", sender: "Elena Conti · Alfa S.r.l.", initials: "EC", subject: "Conferma del termine di consegna", preview: "Possiamo sentirci dopo la call di questa mattina?", time: "08:12", folder: "Altre" },
    { id: "mail-4", sender: "Marco Bianchi", initials: "MB", subject: "Visura aggiornata", preview: "La trovi nella raccolta documenti condivisa.", time: "Ieri", folder: "Altre" },
  ],
  events: [
    { id: "event-1", title: "Call con Alfa S.r.l.", start: "10:30", end: "11:15", kind: "Call", detail: "Online" },
    { id: "event-2", title: "Riunione di team", start: "12:00", end: "12:30", kind: "Riunione", detail: "Spostata dalle 11:30" },
    { id: "event-3", title: "Allineamento Nordest", start: "16:30", end: "17:00", kind: "Call", detail: "Online" },
  ],
  freeTime: { start: "14:00", end: "16:00", label: "2 ore disponibili" },
};
